import { useDevice } from '#imports'
import { defineNuxtPlugin, useNuxtApp } from 'nuxt/app'
import { DeviceEnum } from '#lib/enums'
import type { AppCookies } from '#lib/types'

export default defineNuxtPlugin(() => {
  const device = useDevice()
  const $appCookies = useNuxtApp().$appCookies as AppCookies

  if (!device.isApple || !device.isSafari) {
    $appCookies.layout.value = null
  }

  if (
    $appCookies.layout.value === DeviceEnum.MOBILE ||
    device.isMobileOrTablet
  ) {
    device.isMobile = true
    return
  }

  if (import.meta.client) {
    if (
      (navigator?.maxTouchPoints && device.isApple) ||
      device.isMobileOrTablet
    ) {
      device.isMobile = true
      $appCookies.layout.value = DeviceEnum.MOBILE
      window.location.reload()
    }
  }
})
